import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'unistore/full/react';
import actions from './actions';
import Content from './Content';
import './CreateNewTypePicker.scss';

export default connect(
  [],
  actions
)(function CreateNewTypePicker(props) {
  const history = useHistory();
  return (
    <div className="CreateNewTypePicker">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        fill="none"
        viewBox="0 0 375 50"
        className="CreateNewTypePicker__navigation-bar"
        onClick={() => history.goBack()}
      >
        <path
          fill="#fff"
          d="M27.521 19.38l-.65-.76-8.64 7.38 8.64 7.38.65-.76-7.75-6.62 7.75-6.62z"
        ></path>
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 375 264"
        width="100%"
        className="CreateNewTypePicker__content"
      >
        <text
          fill="#fff"
          style={{ whiteSpace: 'pre' }}
          fontSize="24"
          fontWeight="bold"
          letterSpacing="-.04em"
        >
          <tspan x="132.719" y="31.86">
            Add music
          </tspan>
        </text>

        <g
          pointerEvents="bounding-box"
          onClick={() => history.replace('/new/dynamic-playlist')}
        >
          <rect
            fill="#000"
            fillOpacity="0.001"
            width="375"
            height="88"
            y="72"
          />
          <path
            fill="#fff"
            d="M342.96 117.151l-.649-.761 9.554-8.161-9.554-8.16.649-.76 10.445 8.92-10.445 8.922z"
          ></path>
          <text
            fill="#fff"
            style={{ whiteSpace: 'pre' }}
            fontSize="16"
            fontWeight="bold"
            letterSpacing="0em"
          >
            <tspan x="56" y="105.24">
              Choose artists and more
            </tspan>
          </text>
          <text
            fill="#B3B3B3"
            style={{ whiteSpace: 'pre' }}
            fontSize="13"
            fontWeight="450"
            letterSpacing="0em"
          >
            <tspan x="56" y="124.257">
              Create a playlist inspired by artists and genres{' '}
            </tspan>
            <tspan x="56" y="140.257">
              you choose. It will refresh daily.
            </tspan>
          </text>
          <path
            fill="#fff"
            d="M31.962 110.421l-.961-.552a.495.495 0 01-.244-.349.493.493 0 01.112-.409l1.311-1.537A5.493 5.493 0 0033.5 104v-.5a5.52 5.52 0 00-1.74-4.014 5.454 5.454 0 00-4.125-1.475c-2.879.187-5.134 2.673-5.134 5.66V104c0 1.311.469 2.58 1.319 3.574l1.311 1.538a.493.493 0 01.112.409.489.489 0 01-.243.348l-3.213 1.847A5.514 5.514 0 0019 116.501V118h1v-1.499c0-1.616.874-3.116 2.283-3.917l3.216-1.848c.388-.223.654-.604.73-1.044a1.494 1.494 0 00-.337-1.229l-1.312-1.539A4.5 4.5 0 0123.501 104v-.329c0-2.461 1.845-4.509 4.199-4.66a4.468 4.468 0 013.377 1.205A4.457 4.457 0 0132.5 103.5v.5a4.5 4.5 0 01-1.08 2.925l-1.311 1.537a1.5 1.5 0 00.394 2.274l.479.275c.305-.229.628-.433.98-.59zM36 107.184v5.577a2.993 2.993 0 00-2.013-.788 3.017 3.017 0 00-3.014 3.014 3.017 3.017 0 003.014 3.014A3.017 3.017 0 0037 114.986v-6.071l1.99 1.149.5-.866-3.49-2.014zM33.986 117a2.016 2.016 0 01-2.014-2.014c0-1.11.903-2.014 2.014-2.014a2.015 2.015 0 010 4.028z"
            opacity="0.7"
          ></path>
        </g>

        <g
          pointerEvents="bounding-box"
          onClick={() => history.replace('/new/playlist')}
        >
          <rect
            fill="#000"
            fillOpacity="0.001"
            width="375"
            height="88"
            y="176"
          />
          <path
            fill="#fff"
            d="M342.96 221.151l-.649-.761 9.554-8.161-9.554-8.16.649-.76 10.445 8.92-10.445 8.922z"
          ></path>
          <text
            fill="#fff"
            style={{ whiteSpace: 'pre' }}
            fontSize="16"
            fontWeight="bold"
            letterSpacing="0em"
          >
            <tspan x="56" y="209.24">
              Add songs
            </tspan>
          </text>
          <text
            fill="#B3B3B3"
            style={{ whiteSpace: 'pre' }}
            fontSize="13"
            fontWeight="450"
            letterSpacing="0em"
          >
            <tspan x="56" y="228.257">
              Create a playlist with specific songs. It will{' '}
            </tspan>
            <tspan x="56" y="244.257">
              never refresh.{' '}
            </tspan>
          </text>
          <path
            fill="#fff"
            d="M28.001 205h-1v6h-6v1h6v6h1v-6h6v-1h-6v-6zm-.501-5c-6.351 0-11.5 5.149-11.5 11.5S21.149 223 27.5 223 39 217.851 39 211.5 33.851 200 27.5 200zm0 22c-5.79 0-10.5-4.71-10.5-10.5S21.71 201 27.5 201 38 205.71 38 211.5 33.29 222 27.5 222z"
            opacity="0.7"
          ></path>
        </g>
      </svg>
    </div>
  );
});
